import React from 'react';
import {useFeatureServices} from '../use-feature-services';
import {TrackingService} from './TrackingService';

export function useTrackingService(): TrackingService {
  const {tracking} = useFeatureServices();

  return React.useMemo(() => new TrackingService(tracking), [tracking]);
}
